var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.5,
    fill: "white",
    stroke: "#21A6E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0827 16.8334V40.1667H13.916V16.8334H43.0827ZM38.7077 31.4167H29.9577V33.6042H38.7077V31.4167ZM38.7077 27.0417H29.9577V29.2292H38.7077V27.0417ZM27.041 22.6667H18.291V29.2292H27.041V22.6667ZM38.7077 22.6667H29.9577V24.8542H38.7077V22.6667Z",
    fill: "#21A6E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.a48ba4b921ff65b0c72dd6d2d2f2132a.svg";
export { ForwardRef as ReactComponent };